
//src/pages/ProfessorDashboard.jsx

import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";

import CourseManagement from "../components/admin/CourseManagement";
import CommunicationCenter from "../components/admin/CommunicationCenter";
import AdminEmailTemplates from "../pages/AdminEmailTemplates";

export default function ProfessorDashboard() {
    const { user, hasRole } = useAuth();

    // Permissões: professor, supervisor, admin
    const canAccess =
        hasRole?.(["professor"]) ||
        hasRole?.(["supervisor"]) ||
        hasRole?.(["admin"]);

    const [activeTab, setActiveTab] = useState("courses");

    if (!canAccess) {
        return (
            <div className="container mx-auto p-6">
                <h1 className="text-3xl font-bold text-red-600">
                    Acesso negado: Conteúdo restrito ao Professor/Supervisor.
                </h1>

                <p className="mt-4 text-gray-700">
                    Você não tem permissão para acessar esta área.
                </p>

                <a
                    href="/admin"
                    className="mt-6 inline-block bg-blue-500 text-white px-4 py-2 rounded shadow"
                >
                    Ir para Admin Geral
                </a>
            </div>
        );
    }

    // ------------------------
    // 🔥 Conteúdos das ABAS
    // ------------------------
    const renderContent = () => {
        switch (activeTab) {
            case "courses":
                return <CourseManagement />;
            case "communications":
                return <CommunicationCenter />;
            case "emailTemplates":
                return <AdminEmailTemplates />;
            default:
                return <CourseManagement />;
        }
    };

    return (
        <div className="container mx-auto p-8">

            <h1 className="text-4xl font-bold text-indigo-700 mb-6 border-b pb-4">
                Painel do Professor
            </h1>

            {/* ==================================================================
                ABAS DO PAINEL DO PROFESSOR
            ================================================================== */}
            <div className="border-b border-gray-200 mb-6">
                <nav className="flex space-x-4 flex-wrap">

                    {/* Cursos */}
                    <button
                        onClick={() => setActiveTab("courses")}
                        className={`py-2 px-4 text-sm font-semibold ${
                            activeTab === "courses"
                                ? "border-b-2 border-indigo-600 text-indigo-600"
                                : "text-gray-500 hover:text-gray-700"
                        }`}
                    >
                        Gestão de Cursos 📚
                    </button>

                    {/* Comunicação */}
                    <button
                        onClick={() => setActiveTab("communications")}
                        className={`py-2 px-4 text-sm font-semibold ${
                            activeTab === "communications"
                                ? "border-b-2 border-green-600 text-green-600"
                                : "text-gray-500 hover:text-gray-700"
                        }`}
                    >
                        Comunicações 💬
                    </button>

                    {/* Templates de E-mail */}
                    <button
                        onClick={() => setActiveTab("emailTemplates")}
                        className={`py-2 px-4 text-sm font-semibold ${
                            activeTab === "emailTemplates"
                                ? "border-b-2 border-yellow-600 text-yellow-600"
                                : "text-gray-500 hover:text-gray-700"
                        }`}
                    >
                        Templates de E-mail ✉️
                    </button>
                </nav>
            </div>

            {/* ==================================================================
                RENDER CONTEÚDO
            ================================================================== */}
            <div className="mt-6">{renderContent()}</div>
        </div>
    );
}
